<script setup lang="ts">
import { computed } from 'vue'
import type { DoctorBreak } from '@/type/Appointment'
import { useTranslation } from 'i18next-vue'
import { useAppStore } from '@/stores/AppStore'
import { themeColor } from '@/theme'

interface Props {
  doctorName: string
  startTime: string
  endTime: string
  breaks?: DoctorBreak[]
}

withDefaults(defineProps<Props>(), { breaks: () => [] })
const { t } = useTranslation()
const appStore = useAppStore()

const accentColor = computed(() =>
  appStore.isXpress ? themeColor.xpress.primary2 : themeColor.aura.primary2,
)
</script>

<template>
  <div
    class="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-white tw-p-3"
  >
    <div class="tw-w-[40%] tw-flex-shrink-0">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-rounded-full tw-px-2 tw-py-2 tw-text-center tw-text-xs tw-font-medium tw-text-white"
        :style="{ backgroundColor: accentColor }"
      >
        <van-icon name="clock-o" size="14" color="#fff" />
        <span class="tw-truncate">{{ startTime }} - {{ endTime }}</span>
      </div>
      <p
        v-for="breakTime in breaks"
        :key="`break-time-${breakTime.id}`"
        class="tw-mt-1 tw-flex tw-items-center tw-justify-center tw-gap-1 tw-whitespace-nowrap tw-text-xs tw-text-amber-500"
      >
        <van-icon name="clock-o" size="12" color="#f59e0b" />
        <span>
          {{ t('appointment.break_time', { start: breakTime.start, end: breakTime.end }) }}
        </span>
      </p>
    </div>
    <div class="tw-min-w-0 tw-flex-1 tw-text-center">
      <p class="tw-truncate tw-text-base tw-font-bold" :style="{ color: accentColor }">
        {{ doctorName }}
      </p>
    </div>
  </div>
</template>
